var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.0267 4.86065L10.98 2.81398C10.3533 2.18732 9.50667 1.83398 8.62 1.83398H5.33333C3.33333 1.83398 2 3.16732 2 5.16732V11.834C2 13.834 3.33333 15.1673 5.33333 15.1673H10.6667C12.6667 15.1673 14 13.834 14 11.834V7.21398C14 6.32732 13.6467 5.48065 13.0267 4.86065Z",
    fill: "#CBA135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 9.33398V6.83398H6.66663C5.56663 6.83398 4.66663 7.73398 4.66663 8.83398V9.50065H7.49996C7.59329 9.50065 7.66663 9.42732 7.66663 9.33398Z",
    fill: "#CBA135"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 9.50065H11.3334V8.83398C11.3334 7.73398 10.4334 6.83398 9.33337 6.83398H8.33337V9.33398C8.33337 9.42732 8.40671 9.50065 8.50004 9.50065Z",
    fill: "#CBA135"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 10.166H4.66663V10.8327C4.66663 11.9327 5.56663 12.8327 6.66663 12.8327H7.66663V10.3327C7.66663 10.2393 7.59329 10.166 7.49996 10.166Z",
    fill: "#CBA135"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 10.3327V12.8327H9.33337C10.4334 12.8327 11.3334 11.9327 11.3334 10.8327V10.166H8.50004C8.40671 10.166 8.33337 10.2393 8.33337 10.3327Z",
    fill: "#CBA135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsim);
export default __webpack_public_path__ + "static/media/esim.b5b33afd7c80d074415ce12490b6e123.svg";
export { ForwardRef as ReactComponent };